// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3TeiS","question":"Question_question__2pmNG","description":"Question_description__30fX4"};